const formatNullValue  = (value) => value ?? '';

export default formatNullValue;